import { render, staticRenderFns } from "./algorithm-version-list.vue?vue&type=template&id=24aeb708&"
import script from "./algorithm-version-list.vue?vue&type=script&lang=js&"
export * from "./algorithm-version-list.vue?vue&type=script&lang=js&"
import style0 from "./algorithm-version-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports